<svg viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
<line x1="2.12132" y1="2" x2="34" y2="33.8787" stroke="white" stroke-width="3" stroke-linecap="round"/>
<line x1="34" y1="2.12132" x2="2.12132" y2="34" stroke="white" stroke-width="3" stroke-linecap="round"/>
</svg>
